module.exports = __webpack_public_path__ + "img/board.d426ab3d.webp";